import React from "react";
import "./FeatureOfferCard.scss";
import CustomImg from "./common/CustomImg";
import { Link } from "react-router-dom";
import routes from "../constants/routes";

function FeatureOfferCard(props) {
  const { postItem } = props;
  // console.log(postItem);
  /*
        id: "0df49df8-a202-4114-8d45-6a59dcac4851"
        title: "Free Bota Momo"
        artwork: "https://dev-cdn-offer.fonepay.com/offercontent/offer/a9c5b1b8db3940d49f7aa2f991687bcb"
        dealType: 2
        dealDiscount: 82
        subMerchants: [{…}]
        weight: 0
  */

  return (
    <div className="feature-offer">
      <div className="card">
        <Link
          to={`${routes["offerDetails"]}/${postItem.id}`}
          className=" text-white"
        >
          <CustomImg url={postItem.artwork} />

          <div className="offers position-relative">
            <div className="offer-text position-absolute">
              <h3 className="caption-title">
                <span className="line-clamp-2">{postItem.title}</span>
                {/* <TextTruncate
                  line={2}
                  element="span"
                  truncateText=""
                  text={postItem.title}
                  textTruncateChild=""
                /> */}
              </h3>
              <small className="line-clamp-1">
                {postItem.subMerchants[0].name}

                {/* <TextTruncate
                  line={1}
                  element="span"
                  truncateText=""
                  text={postItem.subMerchants[0].name}
                  textTruncateChild=""
                /> */}
              </small>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default FeatureOfferCard;
